import { EnrichmentMode } from '../storefrontParams.js';
export function isApiSlimLandingPageLink(link) {
    return link.type === EnrichmentMode.SLIM;
}
export function isApiCardLandingPageLink(link) {
    return link.type === EnrichmentMode.CARD;
}
export function isApiFullLandingPageLink(link) {
    return link.type === EnrichmentMode.FULL;
}
export function isGroupedProductLink(link) {
    return link.virtualProductId != null || Boolean(link.productGroupKey);
}
export function toApiFullLandingPageLink(link) {
    return link != null && isApiFullLandingPageLink(link) ? link : null;
}
